export function formatPrice(value) {
    if (value == null) { return ""; }
    try {
        return new Intl.NumberFormat("sk-SK", { style: "currency", currency: "EUR" }).format(value);
    } catch (e) {
        return value + " €";
    }
}
